document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".wim-collection")) {
    addClickEventToVariants();
    addClickEventSelectors();
    document.documentElement.addEventListener("theme:loading:end", () => {
      setTimeout(() => {
        addClickEventToVariants();
        addClickEventSelectors();
        replaceDataSrc();
      }, 100);
    });
    replaceDataSrc();
  }

  initWimNewsletterForm();
});

function addClickEventToVariants() {
  const variants = document.querySelectorAll(".wim-collection .product-card .product-variants .product-variant:not(.added)");

  variants.forEach(variant => {
    const productCard = variant.closest(".product-card");
    attachVariantClickEvent(variant, productCard);
    variant.classList.add("added");
  });
}

function attachVariantClickEvent(variant, productCard) {
  variant.addEventListener("click", function () {
    const variantId = this.getAttribute("data-variant-id");
    if (variantId) {
      setVariantIdAndSubmitForm(variantId, productCard);
    }

    const siblings = this.parentElement.querySelectorAll(".product-variant");
    siblings.forEach(sibling => sibling.classList.remove("current"));
    this.classList.add("current");
  });
}

function addClickEventSelectors() {
  const selectors = document.querySelectorAll(".wim-collection .product-card .size-selector:not(.added)");

  selectors.forEach(selector => {
    selector.classList.add("added");

    selector.addEventListener("click", () => {
      const productCard = selector.closest(".product-card");
      const overlay = createOverlay(productCard, selector);
      document.body.appendChild(overlay);
      document.body.classList.add("no-scroll");
    });
  });
}

function createOverlay(productCard, selector) {
  const overlay = document.createElement("div");
  overlay.className = "overlay-selector";

  const overlayBackground = document.createElement("div");
  overlayBackground.className = "overlay-background";
  overlay.appendChild(overlayBackground);

  const overlayContent = document.createElement("div");
  overlayContent.className = "overlay-content";

  const closeButton = document.createElement("button");
  closeButton.textContent = "Close";
  closeButton.className = "overlay-selector-close";


  if (productCard) {
    const productVariants = productCard.querySelector(".product-variants");
    const selectorText = selector.getAttribute("data-text");

    if (productVariants) {
      const clonedContent = productVariants.cloneNode(true);

      clonedContent.querySelectorAll(".product-variant").forEach(variantElement => {
        attachVariantClickEvent(variantElement, productCard);
      });

      overlayContent.appendChild(closeButton);

      if (selectorText) { 
        const textElement = document.createElement("div");
        textElement.className = "size-selector-text";
        textElement.textContent = selectorText;

        overlayContent.appendChild(textElement);
      }

      overlayContent.appendChild(clonedContent);
    }
  }


  overlay.appendChild(overlayContent);

  const closeOverlay = () => {
    overlay.classList.add("closing"); 
    overlay.addEventListener(
      "animationend",
      () => {
        document.body.removeChild(overlay);
        document.body.classList.remove("no-scroll");
      },
      { once: true }
    );
  };

  overlayBackground.addEventListener("click", closeOverlay);
  closeButton.addEventListener("click", closeOverlay);

  return overlay;
}

function setVariantIdAndSubmitForm(variantId, productCard) {
  if (!productCard) return;

  const form = productCard.querySelector("form");
  if (!form) return;

  const hiddenInput = form.querySelector('input[type="hidden"][name="id"]');
  if (hiddenInput) {
    hiddenInput.value = variantId;
  } else {
    return;
  }

  const submitButton = form.querySelector('button[type="submit"]');
  if (submitButton) {
    setTimeout(() => {
      submitButton.click();
    }, 100);
  }
}

function replaceDataSrc() {
  const productCards = document.querySelectorAll("product-card:not(.has-event)");

  productCards.forEach((card) => { 
    card.classList.add("has-event");

    card.addEventListener("mouseenter", () => {
      card.querySelectorAll("img[data-src]").forEach((img) => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute("data-src");
        }
      });
    });

    card.querySelectorAll(".link-color[data-id]").forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const dataId = link.getAttribute("data-id");
        const targetImage = card.querySelector(`.product-card__media img[data-id="${dataId}"]`);
        const primaryImage = card.querySelector(".product-card__image--primary");
        const secondaryImage = card.querySelector(".product-card__image--secondary");

        if (targetImage) targetImage.style.display = "block";
        if (primaryImage) primaryImage.style.display = "none";
        if (secondaryImage) secondaryImage.style.display = "none";
      });

      link.addEventListener("mouseleave", () => {
        const dataId = link.getAttribute("data-id");
        const targetImage = card.querySelector(`.product-card__media img[data-id="${dataId}"]`);
        const primaryImage = card.querySelector(".product-card__image--primary");
        const secondaryImage = card.querySelector(".product-card__image--secondary");

        if (targetImage) targetImage.style.display = "none";
        if (primaryImage) primaryImage.style.display = "block";
        if (secondaryImage) secondaryImage.style.display = "block";
      });
    });
  });
}

document.documentElement.addEventListener("wim:loading:custom-events", () => {
  setTimeout(() => {
    addClickEventToVariants();
    addClickEventSelectors();
    replaceDataSrc();
  }, 100);
});

function initWimNewsletterForm() {
  const form = document.querySelector('.wim-helium-newsletter');

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(form);
    const values = {};

    for (const [key, value] of formData.entries()) {
      values[key] = value;
    }

    // Opcional: console.log para verificar
    console.log('Datos a enviar a Klaviyo:', values);

    // Envío a Klaviyo
    if (typeof klaviyo !== 'undefined' && typeof klaviyo.push === 'function') {
      klaviyo.push(['identify', {
        $email: values.email,
        'Birthday': values.birthday
      }]);
    } else {
      console.warn('Klaviyo no está disponible en esta página.');
    }
  });
}
